function closeModal(modal)
{
  modal.classList.remove('is-open')
}


export function openModal(modalButton, modal, searchJson, type)
{
  if(modalButton) {
    modalButton.forEach((item) => {
      let ID = item.getAttribute('data-id')

      item.addEventListener('click', function (e) {
        e.preventDefault()
        modal.classList.add('is-open');

        if (type === 'teaser') {
          populateTeaserModal(ID)
        }

        if (type === 'video') {
          populateVideoModal(ID)
        }

        if (searchJson && type === 'heroVideo') {
          populateHeroVideoModal(ID)
        }

        if (searchJson && type === 'space') {
          populateContentModal(ID)
        }

        if (type === 'team') {
          populateTeamVideoModal(ID)
        }
      })
    })
  }
}

export function populateContentModal(ID) {
  let jsonData = document.getElementById('json-spaces')?.textContent;
  if (!jsonData) {
    console.error('json-spaces element or its content not found');
    return;
  }

  let parsedJson;
  try {
    parsedJson = JSON.parse(jsonData);
  } catch (error) {
    console.error('Failed to parse JSON data:', error);
    return;
  }

  let modalTitle = document.getElementById('modal-title');
  let modalText = document.getElementById('modal-text');
  let modalCta = document.getElementById('modal-cta');
  let modalThumbImg = document.getElementById('modal-thumb-img');
  let data = document.getElementById('modal-data');


  if (!parsedJson[ID]) {
    console.error(`No data found for ID: ${ID}`);
    return;
  }

  if (parsedJson[ID].title) {
    modalTitle.innerHTML = parsedJson[ID].title;
  }

  if (parsedJson[ID].content && modalText) {
    modalText.innerHTML = parsedJson[ID].content;
  }

  if (parsedJson[ID].buttonLink && parsedJson[ID].buttonLabel && modalCta) {
    modalCta.innerHTML = `
      <a href="${parsedJson[ID].buttonLink}" target="${parsedJson[ID].buttonTarget || '_self'}" 
         class="btn btn-blue -outline" id="modal-link">
        ${parsedJson[ID].buttonLabel}
      </a>`;
  } else if (modalCta) {
    modalCta.innerHTML = ''; // Clear the CTA if no buttonLink or buttonLabel is found
  }

  if (parsedJson[ID].thumbnail && modalThumbImg) {
    modalThumbImg.src = parsedJson[ID].thumbnail;
  } else if (modalThumbImg) {
    modalThumbImg.src = ''; // Clear the thumbnail if none is found
  }
}


export function populateTeaserModal(ID) {
  let eventCard = document.querySelector('[data-id="'+ID+'"]');
  let iframe = eventCard.getAttribute('data-teaser')

  if(iframe) {
    document.getElementById('modal-teaser-video').innerHTML = iframe
  }
}

export function populateVideoModal(ID) {
  let videoCard = document.querySelector('[data-id="'+ID+'"]');
  let iframe = videoCard.getAttribute('data-video')

  if(iframe) {
    document.querySelector('#modalVideo2 > .modal-content > .modal-data > #modal-teaser-video').innerHTML = iframe
  }
}

export function populateHeroVideoModal(ID) {
  let jsonData = document.getElementById('json-hero-video-modal').textContent
  let parsedJson = JSON.parse(jsonData)

  if(parsedJson[0]['video']) {
    document.querySelector('#modalHeroVideo > .modal-content > .modal-data > #modal-teaser-video').innerHTML = parsedJson[0]['video']
  }
}

export function populateTeamVideoModal(ID) {
  let teamCard = document.querySelector('[data-id="'+ID+'"]');
  let iframe = teamCard.getAttribute('data-teaser')

  if(iframe) {
    document.querySelector('#modalTeamIntro > .modal-content > .modal-data > #modal-teaser-video').innerHTML = iframe
  }
}


// Instance modal
export function spaceModal()
{
  let modal = document.getElementById('modal')
  let modalButton = document.querySelectorAll('.card-space');
  let searchJson = document.getElementById('json-spaces');
  let modalClose = document.querySelectorAll('#closeModalButton')

  if(modalButton && modal) {
    openModal(modalButton,modal, searchJson, 'space')
  }
  modalClose.forEach((item) => {
    if(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault()
        modal.classList.remove('is-open')
      })
    }
  })
}

export function teaserModal()
{
  let modal = document.getElementById('modalTeaser')
  let modalButton = document.querySelectorAll('.open-teaser');
  let modalClose = document.querySelectorAll('#closeModalButton');

  openModal(modalButton,modal, null, 'teaser')
  modalClose.forEach((item) => {
    if(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault()
        if(modal) {
          modal.classList.remove('is-open')
        }
      })
    }
  })
}

export function videoModal()
{
  let modal = document.getElementById('modalVideo2')
  let modalButton = document.querySelectorAll('.open-video');
  let modalClose = document.querySelectorAll('#closeModalButton')

  openModal(modalButton,modal, null, 'video')
  modalClose.forEach((item) => {
    if(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault()
        if(modal) {
          modal.classList.remove('is-open')
        }
      })
    }
  })
}

export function heroVideoModal()
{
  let modal = document.getElementById('modalHeroVideo')
  let modalButton = document.querySelectorAll('.heroModalVideo');
  let searchJson = document.getElementById('json-hero-video-modal');
  let modalClose = document.querySelectorAll('#closeModalButton')

  openModal(modalButton,modal, searchJson, 'heroVideo')
  modalClose.forEach((item) => {
    if(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault()
        modal.classList.remove('is-open')
      })
    }
  })
}


export function teamModal()
{
  let modal = document.getElementById('modalTeamIntro')
  let modalButton = document.querySelectorAll('.open-teaser');
  let modalClose = document.querySelectorAll('#closeModalButton')

  openModal(modalButton,modal, null, 'team')
  modalClose.forEach((item) => {
    if(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault()
        modal.classList.remove('is-open')
      })
    }
  })
}
